import { NumberFormat } from "components/Common/NumberFormat/NumberFormat";
import SalesSlipModalBtn from "components/Common/Modal/Bill/SalesSlipBtn/SalesSlip";
import { Button } from "react-bootstrap";
import { checkProduct } from "src/utils/storage/product";
import { useGetBillHistory } from "src/hooks/api/pay/useGetBillHistory";
import useBillStatement from "src/hooks/Modal/Bill/useBillStatement";
import { IGetMyServiceListRes } from "src/service/types/console.type";
import { serviceNoAtom } from "src/atoms";
import { useRecoilState } from "recoil";
import { useTranslation } from "react-i18next";
import {
  formatDate,
  getSubscriptionTypeText,
  getPayTermText,
} from "src/utils/pay/billUtils";

interface IBillHistorySectionProps {
  // 청구서 보기 함수
  serviceList: IGetMyServiceListRes[];
}
const BillHistorySection = ({ serviceList }: IBillHistorySectionProps) => {
  const isWrapsodyEco = checkProduct("WRAPSODY_ECO");
  const { billHistory, totalPageNumber } = useGetBillHistory({});
  const [serviceNo] = useRecoilState(serviceNoAtom);
  const { product, billType } = serviceList[serviceNo];
  const { t } = useTranslation();
  const { setServiceBillHisUid, goBillStatement } = useBillStatement();
  // console.log("billHistory", billHistory);
  if (!billHistory?.length) {
    return (
      <div className="no_content">
        <div className="image" />
        <h3 className="no_content__title">{t("common.alert.invalidData")}</h3>
      </div>
    );
  }

  const hasCashHistory = billHistory.some(
    (el: any) => el.payCompany === "CASH"
  );

  return (
    <div>
      <div className="mg mt-40">
        <b className="text text--lg text--black">
          {t("siteManagement.paymentHistory.history.title")}
        </b>
      </div>
      <table className="tableMgnt">
        <thead>
          <tr className="top bottom">
            <th colSpan={2}>
              <span>
                {t("siteManagement.paymentHistory.history.paymentSystem")}
              </span>
            </th>
            {billType !== "PROMOTION" && (
              // 프리미엄 경우 결제주기 제거
              <th>
                <span>
                  {t(
                    "siteManagement.paymentHistory.paymentManagement.paymentCycle"
                  )}
                </span>
              </th>
            )}
            <th>
              <span>
                {t("siteManagement.paymentHistory.paymentManagement.user")}
              </span>
            </th>
            {product !== "DSP" && (
              // DSP에서 용량정보 표시안함
              <th>
                <span>
                  {t("siteManagement.createSite.detail.storage.fieldname")} (
                  {t("siteManagement.createSite.detail.storage.byteUnit")})
                </span>
              </th>
            )}
            <th>
              <span>{t("siteManagement.paymentHistory.history.fee")}</span>
            </th>
            <th>
              <span>{t("siteManagement.paymentHistory.history.date")}</span>
            </th>
            <th>
              <span>{t("siteManagement.paymentHistory.history.period")}</span>
            </th>
            {hasCashHistory && (
              <th>
                <span>{t("cashStatus.history")}</span>
              </th>
            )}
            <th></th>
          </tr>
        </thead>
        <tbody>
          {billHistory?.map((item, index: number) => {
            return (
              <tr className="bottom" key={index}>
                <td>
                  <div className="inline-block vertical-middle billMgnt__history billMgnt__historyType">
                    <i className={`icon_${item?.billType}_label`} />
                  </div>
                </td>
                <td>
                  <span>{t(getSubscriptionTypeText(item, isWrapsodyEco))}</span>
                </td>
                {billType !== "PROMOTION" && (
                  // 프리미엄 경우 결제주기 제거
                  <td>
                    <span>{t(getPayTermText(item?.payTerm))}</span>
                  </td>
                )}
                <td>
                  <span>{item?.licenseCount}</span>
                </td>
                {product !== "DSP" && (
                  // DSP에서 용량정보 표시안함
                  <td>
                    <span>{item?.licenseCount * item?.userPerStorage}</span>
                  </td>
                )}
                <td>
                  <span>
                    {String(item?.visiblePrice) === "0" ? (
                      t("siteManagement.paymentHistory.bill.partner.inquiry")
                    ) : (
                      <NumberFormat
                        num={
                          Number(item?.visiblePrice) > 0
                            ? Number(item?.visiblePrice)
                            : item?.totalPrice
                        }
                        currency={item?.currency}
                      />
                    )}
                  </span>
                </td>
                <td>
                  <span>{formatDate(item?.payDate)}</span>
                </td>
                <td>
                  {item?.priceType !== "cancel" && (
                    <span>
                      {formatDate(item?.subscriptionStartDate)}~
                      {formatDate(item?.subscriptionEndDate)}
                    </span>
                  )}
                </td>
                {hasCashHistory && (
                  <td>
                    {item?.payCompany === "CASH"
                      ? t("cashStatus.complete")
                      : ""}
                  </td>
                )}
                <td>
                  {item?.totalPrice > 0 && item?.confirmUrl !== "CANCEL" && (
                    <>
                      <Button
                        // 청구서 버튼
                        type="button"
                        className="serviceMng-btn btn btn-blue btn-sm"
                        onClick={() => {
                          setServiceBillHisUid(item?.serviceBillHisUid);
                          goBillStatement();
                        }}
                      >
                        {t("siteManagement.paymentHistory.history.bill")}
                      </Button>
                      {item?.payCompany === "INICIS" && item?.inicisTid && (
                        // 매출전표 조회 버튼
                        <SalesSlipModalBtn tid={item?.inicisTid} />
                      )}
                    </>
                  )}
                  {item?.totalPrice > 0 &&
                    item?.confirmUrl === "CANCEL" &&
                    t("siteManagement.paymentHistory.history.disagree")}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {totalPageNumber > 0 && (
        <div className="paginationWrap">{/* Pagination placeholder */}</div>
      )}
    </div>
  );
};

export default BillHistorySection;
